import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";

type Props = SvgIconProps & {
  direction?: "right" | "left" | "up" | "down";
};

const AppIconsArrow = React.forwardRef((props: Props, ref: any) => {
  switch (props.direction) {
    case "right":
      return (
        <SvgIcon {...props} ref={ref}>
          <path
            fill="currentColor"
            d="M18.682476,12.1151056c-0.0007305,0.2002134-0.0839348,0.3912773-0.2300186,0.5281906
	L7.7540288,23.3400211c-0.2694368,0.2917118-0.7243381,0.3097706-1.0160499,0.0403328
	c-0.0139723-0.0129051-0.0274272-0.0263596-0.0403323-0.0403328l-1.150094-1.1500931
	c-0.2917118-0.2694359-0.3097692-0.7243385-0.0403323-1.0160503c0.0129051-0.0139732,0.02636-0.0274277,0.0403323-0.0403328
	l9.0303669-9.0201435L5.5526643,3.0949621C5.260952,2.8255253,5.2428946,2.3706241,5.5123315,2.0789123
	C5.5252371,2.0649397,5.538692,2.0514851,5.5526643,2.0385797l1.1483898-1.1500938
	C6.9704909,0.596774,7.4253922,0.5787165,7.717104,0.8481534c0.0139723,0.0129054,0.0274272,0.0263602,0.0403328,0.0403325
	l10.6967239,10.6984282c0.1453381,0.137145,0.227375,0.3283634,0.2266121,0.5281916"
          />
        </SvgIcon>
      );

    case "left":
      return (
        <SvgIcon {...props} ref={ref} sx={{ transform: "rotate(180deg)" }}>
          <path
            fill="currentColor"
            d="M18.682476,12.1151056c-0.0007305,0.2002134-0.0839348,0.3912773-0.2300186,0.5281906
	L7.7540288,23.3400211c-0.2694368,0.2917118-0.7243381,0.3097706-1.0160499,0.0403328
	c-0.0139723-0.0129051-0.0274272-0.0263596-0.0403323-0.0403328l-1.150094-1.1500931
	c-0.2917118-0.2694359-0.3097692-0.7243385-0.0403323-1.0160503c0.0129051-0.0139732,0.02636-0.0274277,0.0403323-0.0403328
	l9.0303669-9.0201435L5.5526643,3.0949621C5.260952,2.8255253,5.2428946,2.3706241,5.5123315,2.0789123
	C5.5252371,2.0649397,5.538692,2.0514851,5.5526643,2.0385797l1.1483898-1.1500938
	C6.9704909,0.596774,7.4253922,0.5787165,7.717104,0.8481534c0.0139723,0.0129054,0.0274272,0.0263602,0.0403328,0.0403325
	l10.6967239,10.6984282c0.1453381,0.137145,0.227375,0.3283634,0.2266121,0.5281916"
          />
        </SvgIcon>
      );

    case "up":
      return (
        <SvgIcon {...props} ref={ref} sx={{ transform: "rotate(-90deg)" }}>
          <path
            fill="currentColor"
            d="M18.682476,12.1151056c-0.0007305,0.2002134-0.0839348,0.3912773-0.2300186,0.5281906
	L7.7540288,23.3400211c-0.2694368,0.2917118-0.7243381,0.3097706-1.0160499,0.0403328
	c-0.0139723-0.0129051-0.0274272-0.0263596-0.0403323-0.0403328l-1.150094-1.1500931
	c-0.2917118-0.2694359-0.3097692-0.7243385-0.0403323-1.0160503c0.0129051-0.0139732,0.02636-0.0274277,0.0403323-0.0403328
	l9.0303669-9.0201435L5.5526643,3.0949621C5.260952,2.8255253,5.2428946,2.3706241,5.5123315,2.0789123
	C5.5252371,2.0649397,5.538692,2.0514851,5.5526643,2.0385797l1.1483898-1.1500938
	C6.9704909,0.596774,7.4253922,0.5787165,7.717104,0.8481534c0.0139723,0.0129054,0.0274272,0.0263602,0.0403328,0.0403325
	l10.6967239,10.6984282c0.1453381,0.137145,0.227375,0.3283634,0.2266121,0.5281916"
          />
        </SvgIcon>
      );

    case "down":
      return (
        <SvgIcon {...props} ref={ref} sx={{ transform: "rotate(90deg)" }}>
          <path
            fill="currentColor"
            d="M18.682476,12.1151056c-0.0007305,0.2002134-0.0839348,0.3912773-0.2300186,0.5281906
	L7.7540288,23.3400211c-0.2694368,0.2917118-0.7243381,0.3097706-1.0160499,0.0403328
	c-0.0139723-0.0129051-0.0274272-0.0263596-0.0403323-0.0403328l-1.150094-1.1500931
	c-0.2917118-0.2694359-0.3097692-0.7243385-0.0403323-1.0160503c0.0129051-0.0139732,0.02636-0.0274277,0.0403323-0.0403328
	l9.0303669-9.0201435L5.5526643,3.0949621C5.260952,2.8255253,5.2428946,2.3706241,5.5123315,2.0789123
	C5.5252371,2.0649397,5.538692,2.0514851,5.5526643,2.0385797l1.1483898-1.1500938
	C6.9704909,0.596774,7.4253922,0.5787165,7.717104,0.8481534c0.0139723,0.0129054,0.0274272,0.0263602,0.0403328,0.0403325
	l10.6967239,10.6984282c0.1453381,0.137145,0.227375,0.3283634,0.2266121,0.5281916"
          />
        </SvgIcon>
      );


	  case undefined:
      return (
        <SvgIcon {...props} ref={ref}>
          <path
            fill="current"
            d="M18.682476,12.1151056c-0.0007305,0.2002134-0.0839348,0.3912773-0.2300186,0.5281906
	L7.7540288,23.3400211c-0.2694368,0.2917118-0.7243381,0.3097706-1.0160499,0.0403328
	c-0.0139723-0.0129051-0.0274272-0.0263596-0.0403323-0.0403328l-1.150094-1.1500931
	c-0.2917118-0.2694359-0.3097692-0.7243385-0.0403323-1.0160503c0.0129051-0.0139732,0.02636-0.0274277,0.0403323-0.0403328
	l9.0303669-9.0201435L5.5526643,3.0949621C5.260952,2.8255253,5.2428946,2.3706241,5.5123315,2.0789123
	C5.5252371,2.0649397,5.538692,2.0514851,5.5526643,2.0385797l1.1483898-1.1500938
	C6.9704909,0.596774,7.4253922,0.5787165,7.717104,0.8481534c0.0139723,0.0129054,0.0274272,0.0263602,0.0403328,0.0403325
	l10.6967239,10.6984282c0.1453381,0.137145,0.227375,0.3283634,0.2266121,0.5281916"
          />
        </SvgIcon>
      );
  }
});

export default AppIconsArrow;
